/* eslint-disable @typescript-eslint/no-unused-vars */
"use client";

import * as X from "@/ui";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

import ZapptaxIcon from "@/assets/shared-zapptax-icon-black.svg";


import "swiper/css";
import "swiper/css/pagination";
import { useTravelerHomePage } from "@/providers/strapi/content/types/singleTypes/traveler-home-page";
import ReactMarkdown from "react-markdown";


// const data = {
//   steps: [
//     {
//       title: {
//         en: "Step 1",
//         fr: "Étape 1",
//       },
//       text: {
//         en: "Enjoy your shopping experience and upload your invoices ",
//         fr: "Profitez de votre shopping et téléchargez vos factures",
//       },
//       image: Step1Image,
//     },
//     {
//       title: {
//         en: "Step 2",
//         fr: "Étape 2",
//       },
//       text: {
//         en: "Get your tax-free form validated by customs",
//         fr: "Validez votre bordereau de détaxe en douane",
//       },
//       image: Step2Image,
//     },
//     {
//       title: {
//         en: "Step 3",
//         fr: "Étape 3",
//       },
//       text: {
//         en: "Relax. Your refund is on its way!",
//         fr: "Recevez votre remboursement",
//       },
//       image: Step3Image,
//     },
//   ],
// };


export function WhyZapptaxSection(props: X.PageProps) {
  const tr = X.useTranslator();

  const content = useTravelerHomePage('howItWorksSection')

  return (
    <section id="why" className="mt-10 -mb-10 xl:my-20 scroll-mt-[120px]">
      <div className="px-mobile-margin xl:px-0 xl:max-w-content xl:mx-auto">
        <h2 className="w-[60%] xl:w-full text-[36px] xl:text-[48px] mb-2 xl:mb-6 leading-tight [&_strong]:font-medium">
          {/* {tr({
            en: <>Tax-free shopping, made <strong>simple</strong>.</>,
            fr: <>La détaxe <strong>facilitée</strong></>,
          })} */}
          <ReactMarkdown>
            {content.title}
          </ReactMarkdown>
        </h2>
        {/* <p className="text-[16px] xl:text-[24px] mb-10">
          {content.subTitle}
          {tr({
            en: <>Enjoy your shopping! Our app will take care of the rest in just 3 easy steps:</>,
            fr: <>Ne pensez qu'à votre plaisir du shopping{X.Nbsp}! Notre app s’occupe du reste en seulement 3 étapes{X.Nbsp}:</>,
          })}
        </p> */}
        <ReactMarkdown components={{
          p: ({ ...props }) => <p {...props} className="text-[16px] xl:text-[24px] mb-10" />
        }}>
          {content.subTitle}
        </ReactMarkdown>
      </div>

      <div className={X.clsx(X.desktopOnly("grid"), "grid-cols-3 gap-6 max-w-content mx-auto")}>
        {content.steps.map((step, i) => (
          <div key={i} className="relative rounded-xl">
            <X.Image
              src={ZapptaxIcon}

              alt="Zapptax"
              className="w-[24px] h-auto absolute top-6 right-6"
            />
            <X.Image
              src={step.backgroundImage.url as string}
              width={step.backgroundImage.size as number}
              height={step.backgroundImage.size as number}
              alt={step.title}
              unoptimized
              className="w-full h-auto object-cover"
            />
            <div className="absolute left-0 right-0 top-2 p-4 flex flex-col gap-2">
              <div className="text-[26px] font-semibold text-center"><ReactMarkdown>{step.title}</ReactMarkdown></div>
              {/* <p className="text-[20px] text-center leading-tight">{step.content}</p> */}
              <ReactMarkdown components={{
                p: ({ ...props }) => <p {...props} className="text-[20px] text-center leading-tight" />
              }}>
                {step.content}
              </ReactMarkdown>
            </div>
          </div>
        ))}
      </div>

      <div className={X.clsx(X.mobileOnly())}>
        <StepsMobile locale={props.locale} />
      </div>

      <div className="px-mobile-margin xl:px-0 xl:max-w-content xl:mx-auto">
        <div className="mt-6 xl:mt-8">
          <X.Button
            desktopLg
            secondary
            exitHref={content.intercomArticleLink}
            // exitHref={tr({
            //   en: "https://help.zapptax.com/en/articles/6383266-how-to-use-zapptax-step-by-step",
            //   fr: "https://help.zapptax.com/fr/articles/6383266-comment-utiliser-zapptax-etape-par-etape",
            //   zh: "https://help.zapptax.com/en/articles/6383266-how-to-use-zapptax-step-by-step",
            // })}
            label={content.cta}
          // label={tr({
          //   en: "More info",
          //   fr: "Plus d'information",
          // })}
          />
        </div>
      </div>
    </section>
  );
}


function StepsMobile(props: X.PageProps) {
  const id = X.useId();
  const content = useTravelerHomePage('howItWorksSection')
  return (
    <Swiper
      spaceBetween={16}
      slidesPerView={1.6}
      slidesOffsetBefore={32}
      slidesOffsetAfter={32}
      className="h-full"
      modules={[Pagination]}
      pagination={{
        el: `#${id}`,
        bulletActiveClass: "w-8 !bg-surface-gray-darker",
        bulletClass: "block w-2 h-2 bg-surface-gray rounded-full transition-all duration-300",
        clickable: false,
      }}
    >
      {content.steps.map((step, i) => (
        <SwiperSlide key={i}>
          <div className={X.clsx(i === 0 && "", "relative rounded-xl")}>
            <X.Image
              src={ZapptaxIcon}
              alt="Zapptax"
              className="w-[20px] h-auto absolute top-4 right-4"
            />
            <X.Image
              src={step.backgroundImage.url}
              width={step.backgroundImage.size as number}
              height={step.backgroundImage.size as number}
              alt={step.title}
              className="h-auto w-full object-cover rounded-xl"
            />
            <div className="absolute left-0 right-0 top-2 p-2 flex flex-col">
              <div className="text-[18px] font-semibold text-center"><ReactMarkdown>{step.title}</ReactMarkdown></div>
              {/* <p className="text-[14px] text-center">{step.content}</p> */}
              <ReactMarkdown components={{
                p: ({ ...props }) => <p {...props} className="text-[14px] text-center leading-tight" />
              }}>
                {step.content}
              </ReactMarkdown>
            </div>
          </div>
        </SwiperSlide>
      ))}

      <div id={id} className="mx-mobile-margin flex flex-row gap-2 mt-4" />
    </Swiper>
  );
}
